import React, { FC } from 'react';
import Premium from 'images/whiteIcons/Premium.svg?react';
import { useIsPremium } from 'hooks/userIsPremium';
import { SPremiumDiv, SPremiumDivActivated } from './styles';
import { useTranslation } from 'react-i18next';

const PremiumIcon: FC = () => {
    const isPremium = useIsPremium();
    const { t } = useTranslation();

    return isPremium ? (
        <SPremiumDivActivated title={t('premium-icon.title')}>
            <Premium />
        </SPremiumDivActivated>
    ) : (
        <SPremiumDiv title={t('premium-icon.title')}>
            <Premium />
        </SPremiumDiv>
    );
};

export default PremiumIcon;
